import React, { useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

function Thankyou({ onClose }) {
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 10000);
  }, []);
  return (
    <div className="thankyou-page">
      <div className="row align-items-center h-100">
        <div className="text-center">
          <FontAwesomeIcon className="icon" icon={faCheckCircle} />
          <p>ขอบคุณสำหรับความคิดเห็นของท่าน</p>
        </div>
      </div>
    </div>
  );
}

export default Thankyou;
